import { render, staticRenderFns } from "./shopee.vue?vue&type=template&id=3dc41753&scoped=true&"
import script from "./shopee.vue?vue&type=script&lang=js&"
export * from "./shopee.vue?vue&type=script&lang=js&"
import style0 from "./shopee.vue?vue&type=style&index=0&id=3dc41753&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc41753",
  null
  
)

export default component.exports